export const helpEnLocale = {
  'help.title': 'Help Center',

  'help.buy': 'How to buy?',
  'help.buyBody':
    'To buy tickets, simply select the event you want to attend, choose the quantity of tickets and proceed to payment. You can do it through our website. We accept payments with credit card or debit card. You can also pay in cash at our sales points.',
  'help.buyBody2':
    'Certain events offer the option of payment at the box office, where you can pay in cash at the event venue.',

  'help.get': 'What do I get with my purchase?',
  'help.getBody1':
    'At the end of your purchase, you will receive an email with your eTicket attached, which has a QR code that makes your purchase 100% secure. To enter your event, all you have to do is print it or show it from your phone at the entrance assigned to your location so that Smart Ticket staff can scan your code and enjoy the show.',
  'help.getBody2':
    'You can also add them to your digital wallet (Google Wallet) to facilitate access.',

  'help.choose': 'Can I choose my seat?',
  'help.chooseBody':
    'Yes, in events with numbered seats, you can choose your seat during the purchase process. If the event is general admission, no specific seats are assigned and entry is on a first-come, first-served basis.',

  'help.succes': 'How can I make sure my purchase was successful?',
  'help.succesBody':
    'After completing your purchase, you will receive a confirmation email. If you do not receive it in the next few minutes, check your spam folder. You can also check your purchase history in the "My Tickets" section of our website.',

  'help.cancel': 'Can I cancel or change my ticket?',
  'help.cancelBody':
    'Once the purchase is made, tickets are non-refundable. We recommend that you verify the event details carefully before confirming the purchase.',

  'help.eventDay': 'What should I do on the day of the event?',
  'help.eventDayBody':
    'On the day of the event, you only need to show your digital ticket at the entrance. Make sure you have it ready on your mobile device or in your digital wallet (Google Wallet) to speed up entry. Arrive at the event with enough time to avoid setbacks.',

  'help.discount': 'Are discounts available?',
  'help.discountBody':
    "Some events offer special discounts. Check Smart Ticket {country}, the organizer's or artist's social networks to see if there is any discount available. If you have a discount code, you can enter it in the corresponding section during the purchase process.",

  'help.sell': 'Our sales points',
  'help.kiosk': 'Smart Ticket Kiosks',
  'help.sv': 'Galerías Shopping Center',
  'help.gt1': 'Galerías Shopping Center',
  'help.gt2': '3rd Avenue 12- 3b Zone 10',
  'help.hn1': 'Multiplaza Mall, 3rd floor inside the Food Court',
  'help.hn2': 'A.V. Roble, Tegucigalpa',
  'help.omnimusic': 'Omnimusic Stores',
  'help.sonsonate1': 'Monday to Friday from 9:00 a.m. to 5:00 p.m.',
  'help.sonsonate2': 'Saturday from 9:00 am to 1:00 pm',
  'help.santaana1': 'Monday to Friday from 8 a.m. to 5 p.m.',
  'help.santaana2': 'Saturday from 8 a.m. to 3 p.m.',
  'help.sanmiguel1': 'Monday to Friday from 8:00 a.m. to 5:00 p.m.',
  'help.sanmiguel2': 'Saturday from 8:00 a.m. to 1:00 p.m.',
  'help.apopa1': 'Monday to Friday 9:00 a.m. to 6:00 p.m.',
  'help.apopa2': 'Saturday from 9:00 a.m. to 7:00 p.m.',
  'help.apopa3': 'Sunday from 10:00 a.m. to 6:00 p.m.',
  'help.soyapango1': 'Monday and Tuesday from 9:00 a.m. to 6:00 p.m.',
  'help.soyapango2': 'Wednesday to Saturday from 9:00 a.m. to 7:00 p.m.',
  'help.soyapango3': 'Sunday from 10:00 a.m. to 6:00 p.m.',
  'help.ampm': 'AM PM Stores',
} as const;

export const helpEsLocale = {
  'help.title': 'Centro de Ayuda',

  'help.buy': '¿Cómo comprar?',
  'help.buyBody':
    'Para comprar boletos, simplemente selecciona el evento al que deseas asistir, elige la cantidad de boletos y procede al pago. Puedes hacerlo a través de nuestra página web. Aceptamos pagos con tarjeta de crédito o débito. También puedes pagar en efectivo en nuestros puntos de venta.',
  'help.buyBody2':
    'Ciertos eventos ofrecen la opción de pago en taquilla, donde puedes pagar en efectivo en el lugar del evento.',

  'help.get': '¿Qué recibo con mi compra?',
  'help.getBody1':
    'Al finalizar tu compra recibirás un correo con tu eTicket o Ticket Electrónico adjunto, el cual posee un código QR que hace tu compra 100% segura. Para ingresar a tu evento lo único que debes hacer es imprimirlo o mostrarlo desde tu celular en la entrada asignada para tu localidad para que personal de Smart Ticket pueda escanear tu código y disfrutes de la función.',
  'help.getBody2':
    'También puedes agregarlos a tu billetera digital (Google Wallet) para facilitar el acceso.',

  'help.choose': '¿Puedo elegir mi asiento?',
  'help.chooseBody':
    'Sí, en eventos con asientos numerados, podrás elegir tu asiento durante el proceso de compra. Si el evento es de entrada general, no se asignan asientos específicos, la entrada es por orden de llegada.',

  'help.succes': '¿Cómo puedo asegurarme de que mi compra fue exitosa?',
  'help.succesBody':
    'Después de completar tu compra, recibirás una confirmación por correo electrónico. Si no la recibes en los próximos minutos, revisa tu bandeja de spam. También puedes verificar tu historial de compras en la sección "Mis boletos" de nuestra página.',

  'help.cancel': '¿Puedo cancelar o cambiar mi boleto?',
  'help.cancelBody':
    'Una vez realizada la compra, los boletos no son reembolsables. Te recomendamos verificar bien los detalles del evento antes de confirmar la compra.',

  'help.eventDay': '¿Qué debo hacer el día del evento?',
  'help.eventDayBody':
    'El día del evento, solo necesitas mostrar tu boleto digital en la entrada. Asegúrate de tenerlo listo en tu dispositivo móvil o en tu billetera digital (Google Wallet) para agilizar el ingreso. Llega al evento con tiempo suficiente para evitar contratiempos.',

  'help.discount': '¿Hay descuentos disponibles?',
  'help.discountBody':
    'Algunos eventos ofrecen descuentos especiales. Revisa las redes sociales de Smart Ticket {country}, del organizador o el artista para saber si hay algún descuento disponible. Si tienes un código de descuento, puedes ingresarlo en la sección correspondiente durante el proceso de compra.',

  'help.sell': 'Nuestros puntos de venta',
  'help.kiosk': 'Kioskos Smart Ticket',
  'help.sv': 'Centro Comercial Galerías',
  'help.gt1': 'Centro Comercial Galerías',
  'help.gt2': '3ra avenida 12- 3b Zona 10',
  'help.hn1': 'Mall Multiplaza, piso 3 dentro del FoodCourt',
  'help.hn2': 'A.V. Roble, Tegucigalpa',
  'help.omnimusic': 'Tiendas Omnimusic',
  'help.sonsonate1': 'Lunes a Viernes de 9:00 a.m. a 5:00 p.m.',
  'help.sonsonate2': 'Sábado de 9:00 am a 1:00 pm',
  'help.santaana1': 'Lunes a Viernes de 8 a 5 p.m.',
  'help.santaana2': 'Sábado de 8 a 3 p.m.',
  'help.sanmiguel1': 'Lunes a Viernes de 8:00 a 5:00 pm',
  'help.sanmiguel2': 'Sábado de 8:00 a 1:00 pm',
  'help.apopa1': 'Lunes a Viernes 9:00 a 6:00 pm',
  'help.apopa2': 'Sábado de 9 00 a 7:00 pm',
  'help.apopa3': 'Domingo de 10:00 a 6:00pm',
  'help.soyapango1': 'Lunes y martes 9:00 am a 6:00 pm',
  'help.soyapango2': 'Miércoles a Sábado de 9:00 a.m. a 7:00 p.m.',
  'help.soyapango3': 'Domingo de 10:00 a.m. a 6:00 p.m.',
  'help.ampm': 'Tiendas AM PM',
} as const;
